import { makeStyles, createStyles } from '@material-ui/core/styles';

const qrStyle = makeStyles(() =>
  createStyles({
    contentForm: { maxWidth: '300px', margin: 'auto' },
  })
);

export default qrStyle;
